import Entity from './entity'

export default class HandoverSession extends Entity<number>{
    code:string;
    transferredBy :number;
    transferredTime : Date;
    refCode :string;
    refTypeCode :string;
    creatorUserId : string;
    creationTime : Date
    numOfPackages :number;
    deliveryPartnerName :string;
    status:string;
    canUpdate: boolean;
    refTypeName:string;
    statusName:string;
}